import {makeStyles } from '@material-ui/core/styles';

export const useStyles  = makeStyles((theme) => ({ 
    eventContainer: {
        borderRadius: 12,
        marginTop: 30 
    },
    table: {
        minWidth: 650,
        [theme.breakpoints.down('sm')]: {
            width: 900
        }
    },
    eventText: {
        margin: 0,
        fontWeight : '500',
        fontSize: 30,
        color: '#091E42',
        fontFamily: 'Roboto'
    },
}));

